module.exports = __webpack_public_path__ + "img/enterprise3.592e8fea.png";